import { Fragment } from 'react';
import ProductsImg from '../images/Products.PNG';
import Product1 from '../images/Product1.PNG';
import Product2 from '../images/Product2.PNG';
import Product3 from '../images/Product3.PNG';
import Product4 from '../images/Product4.PNG';
import Product5 from '../images/Product5.PNG';
import "./pages.css"
import Footer from '../pages/Footer';

const Products =() => {
    return (
        <Fragment>
            <img src={ ProductsImg } className="avatar-home" alt="avatar" />
            <div className='home-container'>
                <div className={ 'what-content-container' }>
                    <div className={ 'what-content product-content' }>
                        <h2 style={ { fontWeight: 'bold' } }>Stainless Steel</h2>
                        <hr size="2" color="blue" />
                        <p>We work hand in hand with leading companies, ensuring that Vanadium provides you with access to 
                           high-quality stainless steel grades at exceptionally competitive prices. Our skilled logistics 
                           team excels in efficiently transporting stainless steel containers directly from your warehouse to 
                           companies as per your requirements.
                        </p>
                        <ul className="what-content-list">
                            <li>Stainless steel bars</li>
                            <li>Stainless steel sheets</li>
                            <li>Stainless steel plates</li>
                            <li>Stainless steel coils</li>
                            <li>Stainless steel rods</li>
                            <li>Stainless steel pipes</li>
                        </ul>
                    </div>
                    <img align="right" src={ Product1 } className="avatar product-avatar" alt="avatar" width="400px" height="380px" />
                </div>
                <div className={ 'what-content-container' }>
                    <div className={ 'what-content product-content' }>
                        <h2 style={ { fontWeight: 'bold' } }>Aluminum Alloy</h2>
                        <hr size="2" color="blue" />
                        <p>Vanadium boasts an broad network of esteemed clients situated in Europe, India, and China, each renowned 
                           for producing top-quality aluminium across various grades. Backed by stringent testing procedures and 
                           thorough documentation, our expertise lies in efficiently transporting containers across oceans to deliver 
                           these superior aluminium products right to your doorstep, all at remarkably competitive prices.
                        </p>
                        <ul className="what-content-list">
                            <li>Aluminum bars</li>
                            <li>Aluminum plates</li>
                            <li>Aluminum coils</li>
                            <li>Aluminum rods</li>
                            <li>Aluminum pipes</li>
                            <li>Aluminum sheets</li>
                        </ul>
                    </div>
                    <img align="right" src={ Product2 } className="avatar product-avatar" alt="avatar" width="400px" height="380px" />
                </div>
                <div className={ 'what-content-container' }>
                    <div className={ 'what-content product-content' }>
                        <h2 style={ { fontWeight: 'bold' } }>Copper</h2>
                        <hr size="2" color="blue" />
                        <p>Vanadium is honoured to collaborate with worlds best location and custom copper smelters worldwide. We're 
                           thrilled to offer a streamlined copper sourcing solution, delivering directly to customers, alleviating 
                           the hassles of import and duty taxes.
                        </p>
                        <ul className="what-content-list">
                            <li>Copper plates</li>
                            <li>Copper rods</li>
                            <li>Copper wire</li>
                            <li>Copper tube</li>
                            <li>Copper sheets</li>
                            <li>Copper pipes</li>
                        </ul>
                    </div>
                    <img align="right" src={ Product4 } className="avatar product-avatar" alt="avatar" width="400px" height="380px" />
                </div>
                <div className={ 'what-content-container' }>
                    <div className={ 'what-content product-content' }>
                        <h2 style={ { fontWeight: 'bold' } }>Other Metals</h2>
                        <hr size="2" color="blue" />
                        <p>Leveraging a seasoned sourcing team, Vanadium guarantees the procurement of metals tailored to your 
                           specifications, irrespective of size, shape, or quantity. We secure the best deals for you by tapping into 
                           our extensive world-wide network of suppliers.
                        </p>
                        <ul className="what-content-list">
                            <li>Brass</li>
                            <li>Bronze</li>
                            <li>Tool Steel</li>
                            <li>Bright Steel</li>
                            <li>Titanium</li>
                            <li>Zinc</li>
                            <li>And others</li>
                        </ul>
                    </div>
                    <img align="right" src={ Product5 } className="avatar product-avatar" alt="avatar" width="400px" height="380px" />
                </div>
            </div>
            <Footer />
        </Fragment>
    )
};
export default Products;
